// @flow
import type { MediaPath } from 'types/common';
import type { CampaignDetails } from 'types/campaign';
import { filter } from 'lodash';

const mapCampaignDetails = (
  campaignDetails,
  mediaPath: MediaPath,
  campaign_url_slug
): Array<CampaignDetails> => {
  if (campaignDetails.length > 0) {
    let DetailsData = [];
    campaignDetails.map((campaign_data, idx) => {
      DetailsData.push(mapCampaignData(campaign_data, mediaPath));
    });
    DetailsData = filter(
      DetailsData,
      extractedData => extractedData.url_slug === campaign_url_slug
    );
    return DetailsData;
  }

  return [];
};

const mapCampaignData = (campaign_data, mediaPath) => {
  return {
    id: campaign_data.id,
    title: campaign_data.title,
    description: campaign_data.campaign_description,
    description_mobile: campaign_data.campaign_mobile_description,
    image: `${mediaPath.web}/${campaign_data.campaign_banner}`,
    image_mobile: `${mediaPath.mobile}/${campaign_data.mobile_campaign_banner}`,
    thumbnail: `${mediaPath.thumbnail}/${campaign_data.campaign_banner}`,
    thumbnail_mobile: `${mediaPath.thumbnail}/${campaign_data.mobile_campaign_banner}`,
    metaTagSEO: {
      metaTitle: campaign_data.meta_title ? campaign_data.meta_title : '',
      metaDescription: campaign_data.meta_description
        ? campaign_data.meta_description
        : '',
      metaKeywords: campaign_data.meta_keyword
        ? campaign_data.meta_keyword
        : '',
    },
    url_slug: campaign_data.url_slug,
    banner_video: campaign_data.header_video,
  };
};

export const CampaignMapper = {
  mapCampaignDetails,
};
